import { Field, Label } from '@stories/Elements/Forms/Fields/Form.styles';
import React, { FunctionComponent } from 'react';
import { TextboxInput } from './Textbox.styles';

export enum TextboxTheme {
  White = 1,
  Black = 2,
  Red = 3,
  Red_Base = 4,
  White_Text = 5,
}

interface TextboxProps {
  theme?: TextboxTheme;
}

const Textbox: FunctionComponent<TextboxProps> = ({ theme }) => {
  return (
    <Field>
      <Label htmlFor="txtFirstName" theme={theme}>
        First Name
      </Label>
      <TextboxInput id="txtFirstName" placeholder="First Name" theme={theme}></TextboxInput>
    </Field>
  );
};

export default Textbox;
